import { APP_URL } from "../constants";
import { httpClient } from "../utils/http-client";

const fetchCountries = (token, { offset = 0, limit = 100 } = {}) => {
  try {
    const params = new URLSearchParams({
      page: String(offset),
      size: String(limit),
    });
    const headers = {
      locale: navigator.language,
    };
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    return httpClient.get(`${APP_URL}/v1/countries?${params}`, headers);
  } catch (error) {
    console.log("Error getting countries", error);
  }
};

const toActiveCountryOptions = (countries = []) =>
  Array.from(
    new Map(
      countries
        .filter((country) => country?.name && country.status === "ACTIVE")
        .map((country) => [country.name, { value: country.name, label: country.name }])
    ).values()
  ).sort((a, b) => a.label.localeCompare(b.label));

const fetchActiveCountryOptions = async (token) => {
  const pageSize = 100;
  let offset = 0;
  let total = Infinity;
  const countries = [];

  while (offset < total) {
    const res = await fetchCountries(token, { offset, limit: pageSize });
    if (!res || res.status_code !== 200) {
      throw new Error(res?.message || "Could not load countries");
    }
    const batch = res.data?.countries || [];
    countries.push(...batch);
    total = Number(res.data?.total ?? countries.length);
    if (batch.length === 0) break;
    offset += pageSize;
  }

  return toActiveCountryOptions(countries);
};

export { fetchCountries, fetchActiveCountryOptions, toActiveCountryOptions };
